import BreadCrumb from '../../../component/BreadCrumb';
import { VIEW_SYSTEM_USER } from '../../../constant/ViewConstant';
import { useDispatch, useSelector } from 'react-redux';
import { useRef, useState, useEffect, useMemo } from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import { CODE_GROUP_ID } from '../../../constant/Constant';
import CodeUtil from '../../../util/CodeUtil';
import PopupRef from '../../../component/PopupRef';
import { modalType } from '../../../util/ModalUtil';
import DeleteIcon from '../../../component/icon/DeleteIcon';
import SelectionBox from '../../../component/SelectionBox';
import SearchButtonBox from '../../../component/buttons/SearchButtonBox';
import RegistButtonBox from '../../../component/buttons/RegistButtonBox';
import SystemUserModal from '../../modal/SystemUserModal';
import TableBox from '../../../component/TableBox';
import ModalRef from '../../../component/ModalRef';
import { useLocation } from 'react-router-dom';
import { actionUserSearch, actionUserRemove, actionChangeUser } from '../../../module/body/system/SystemUserModule';
import { defaultGridData, handleControl, initGrid } from '../../../module/component/TableBoxModule';
import qs from 'qs';
import NullCheckUtil from '../../../util/NullCheckUtil';
import FormatUtil from '../../../util/FormatUtil';
import PathUtil from '../../../util/PathUtil';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import InputBox from '../../../component/InputBox';
import { OpenEditIcon } from '../../../component/icon/GridIcons';
import SessionStorageUtil from '../../../util/SessionStorageUtil';

const ConditionArea = ({ modalRef, popupRef }) => {
    const location = useLocation();
    const queryData = qs.parse(location.search, { ignoreQueryPrefix: true });
    const dispatch = useDispatch();

    const semesterId = SessionStorageUtil.getCurrentSemesterId();
    const [userUniversityCd, setUserUniversityCd] = useState('');
    const [userRoleCd, setUserRoleCd] = useState('');
    const [userNm, setUserNm] = useState('');
    const [params, setParams] = useState({});
    const { gridData } = useSelector((state) => state.tableBoxState);

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onRowDoubleClick,
                onChangePageInfo,
                params,
            }),
        );

        queryData.userUniversityCd && setUserUniversityCd(queryData.userUniversityCd);
        queryData.userRoleCd && setUserRoleCd(queryData.userRoleCd);
        queryData.userNm && setUserNm(queryData.userNm);

        onClickSearch({
            userUniversityCd: queryData.userUniversityCd,
            userRoleCd: queryData.userRoleCd,
            userNm: queryData.userNm,
            page: NullCheckUtil.isNotNull(queryData.page) ? queryData.page : defaultGridData.page,
            pageSize: NullCheckUtil.isNotNull(queryData.pageSize) ? queryData.pageSize : 10,
        });

        return () => {
            dispatch(initGrid());
        };
    }, []);

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onRowDoubleClick,
                onChangePageInfo,
                params,
            }),
        );
    }, [params]);

    const onChangePageInfo = (page, pageSize) => {
        onClickSearch({
            ...params,
            page,
            pageSize,
        });
    };

    const onClickSearch = (params) => {
        setParams(params);
        dispatch(
            actionUserSearch({
                params,
                callback: (result) => {
                    if (result.totalCount == 0) {
                        popupRef.current.openAlert('조회된 결과가 없습니다.');
                    }
                },
            }),
        );
        PathUtil.pushState(location.pathname, params);
    };

    const onRowDoubleClick = (row, params) => {
        modalRef.current.open(
            <SystemUserModal
                type={modalType.EDIT}
                modalRef={modalRef}
                row={row}
                callback={() => {
                    onClickSearch(params);
                }}
            />,
            'medium',
        );
    };

    const handleDelete = (row, params) => {
        popupRef.current.openWarning(row.userNm + '(를)을 삭제하시겠습니까?', () => {
            return function () {
                dispatch(
                    actionUserRemove({
                        params: {
                            semesterId,
                            userId: row.userId,
                        },
                        callback: () => {
                            popupRef.current.openInfo(row.userNm + '(가)이 삭제되었습니다.', () => {
                                return function () {
                                    onClickSearch(params);
                                };
                            });
                        },
                    }),
                );
            };
        });
    };

    const handleChangeUser = (row) => {
        popupRef.current.openWarning(row.userNm + '(으)로 전환하시겠습니까?', () => {
            return function () {
                dispatch(
                    actionChangeUser({
                        data: {
                            userId: row.userId,
                        },
                    }),
                );
            };
        });
    };

    const handleAdd = (params) => {
        modalRef.current.open(
            <SystemUserModal
                type={modalType.ADD}
                modalRef={modalRef}
                callback={() => {
                    onClickSearch(params);
                }}
            />,
            'medium',
        );
    };

    const onKeyDown = (e) => {
        if (e.key == 'Enter') {
            onClickSearch({
                userUniversityCd,
                userRoleCd,
                userNm,
                page: defaultGridData.page,
                pageSize: gridData.pageSize,
            });
        }
    };

    const columns = useMemo(
        () => [
            {
                field: 'userId',
                headerName: 'ID',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'userRoleCd',
                headerName: '역할',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
                renderCell: (params) => CodeUtil.getCodeName(CODE_GROUP_ID.USER_ROLE, params.row.userRoleCd),
            },
            {
                field: 'userUniversityCd',
                headerName: '대학',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
                renderCell: (params) => {
                    if (NullCheckUtil.isNotEmpty(params.row.userUniversityCd)) {
                        return CodeUtil.getCodeName(CODE_GROUP_ID.USER_UNIVERSITY, params.row.userUniversityCd);
                    } else {
                        return params.row.userUniversityCd;
                    }
                },
            },
            {
                field: 'userNm',
                headerName: '이름',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },

            {
                field: 'email',
                headerName: '이메일',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'telNo',
                headerName: '연락처',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
                renderCell: (params) => FormatUtil.telNoFormatter(params.row.telNo),
            },
            {
                field: 'detail',
                headerName: '기능',
                headerAlign: 'center',
                align: 'center',
                flex: 10,
                disableColumnMenu: true,
                hideSortIcons: true,
                disableExport: true,
                renderCell: (item) => (
                    <>
                        <Tooltip title='수정'>
                            <IconButton onClick={(e) => onRowDoubleClick(item.row, params)}>
                                <OpenEditIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title='삭제'>
                            <IconButton onClick={(e) => handleDelete(item.row, params)}>
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title='사용자전환'>
                            <IconButton onClick={(e) => handleChangeUser(item.row)}>
                                <ExitToAppIcon />
                            </IconButton>
                        </Tooltip>
                    </>
                ),
            },
        ],
        [params],
    );

    return (
        <>
            <div className='con-form-wrap '>
                <div className='board-inner'>
                    <div className='board-row'>
                        <div className='lec-check-box'>
                            <div className='search-condition-box'>
                                <div className='form-box-container'>
                                    <SelectionBox
                                        title='역할'
                                        w140
                                        options={CodeUtil.getCodes(CODE_GROUP_ID.USER_ROLE)}
                                        value={userRoleCd}
                                        onChange={(e) => setUserRoleCd(e.target.value)}
                                        onKeyDown={(e) => onKeyDown(e)}
                                    />
                                    <SelectionBox
                                        title='대학'
                                        w140
                                        options={CodeUtil.getCodes(CODE_GROUP_ID.USER_UNIVERSITY)}
                                        value={userUniversityCd}
                                        onChange={(e) => setUserUniversityCd(e.target.value)}
                                        onKeyDown={(e) => onKeyDown(e)}
                                    />
                                    <InputBox
                                        title='이름'
                                        value={userNm}
                                        onChange={(e) => setUserNm(e.target.value)}
                                        onKeyDown={(e) => onKeyDown(e)}
                                    />
                                </div>
                            </div>
                            <div className='lec-check-btn'>
                                <SearchButtonBox
                                    title='조회'
                                    onClick={(e) =>
                                        onClickSearch({
                                            userUniversityCd,
                                            userRoleCd,
                                            userNm,
                                            page: defaultGridData.page,
                                            pageSize: gridData.pageSize,
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='con-tb-wrap'>
                <div className='con-tb-title  '>
                    <h3 className='tb-tit-name'>사용자 목록</h3>
                    <RegistButtonBox onClick={(e) => handleAdd(params)} />
                </div>
            </div>
        </>
    );
};

const SystemUserView = () => {
    const popupRef = useRef(null);
    const modalRef = useRef(null);
    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='con-title-wrap conbg02'>
                    {/* <h2 className='con-title'>참여대학관리</h2> */}
                    <h2 className='con-title'>{VIEW_SYSTEM_USER.title}</h2>
                    <p className='con-title-p'>{VIEW_SYSTEM_USER.subTitle}</p>
                </div>
                <div className='sub-nav-wrap'>
                    <BreadCrumb />
                </div>
                <ConditionArea modalRef={modalRef} popupRef={popupRef} />
                <TableBox defaultWide={false} />
            </div>
            <PopupRef ref={popupRef} />
            <ModalRef ref={modalRef} />
        </section>
    );
};

export default SystemUserView;
